import React, { ReactElement } from 'react'
import { jsonKeyMapping } from '../../../Config/Constants'
import { TemplateObject } from '../../../Models/TemplateObject'
import { removeSemicolons } from '../../../Util/TextUtils'
import Card from 'react-bootstrap/Card'

type Props = {
    formElement: TemplateObject
}

const InputInformation = ({ formElement }: Props): ReactElement => {
    // Remove semicolons from label text
    const labelText = removeSemicolons(formElement[jsonKeyMapping.FORM_LABEL]);
    
    return (
        <Card body className='m1-1 p-0'>
            {labelText}
        </Card>
    )
}

export default InputInformation
